import type { RevolugoConfig } from '@revolugo/elements-vue3'

export const updateConfig = (config: Partial<RevolugoConfig>): void => {
  if (!window) {
    return
  }

  window.RevolugoElements = window.RevolugoElements || {}

  window.RevolugoElements.config = {
    ...window.RevolugoElements.config,
    ...config,
  }
}
